import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white pt-24 pb-12 rounded-t-[4rem] relative z-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20">
          {/* Company Info */}
          <div className="space-y-8">
            <Link to="/" className="inline-block">
              <img
                src="/rita_logo_2-removebg-preview.png"
                alt="Rita Logo"
                className="h-20 w-auto object-contain brightness-0 invert"
              />
            </Link>
            <p className="text-gray-400 text-lg leading-relaxed">
              Universal multi-business QR payment and discovery platform.
              Connecting businesses with customers seamlessly.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-400 hover:text-white transition-all transform hover:scale-110" aria-label="Facebook">
                <Facebook size={24} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-all transform hover:scale-110" aria-label="Twitter">
                <Twitter size={24} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-all transform hover:scale-110" aria-label="Instagram">
                <Instagram size={24} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-all transform hover:scale-110" aria-label="LinkedIn">
                <Linkedin size={24} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-8 italic">Platform</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white text-lg transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white text-lg transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/features" className="text-gray-400 hover:text-white text-lg transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white text-lg transition-colors">
                  Our Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-xl font-bold mb-8 italic">Resources</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-white text-lg transition-colors">
                  Latest Stories
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-gray-400 hover:text-white text-lg transition-colors">
                  Customer Love
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white text-lg transition-colors">
                  Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Get App */}
          <div className="lg:col-span-1">
            <h3 className="text-xl font-bold mb-8 italic">Get the App</h3>
            <div className="flex flex-col gap-4">
              <a href="#" className="bg-white/10 hover:bg-white/20 border border-white/10 px-6 py-3 rounded-2xl flex items-center gap-4 transition-all group">
                <div className="text-left">
                  <p className="text-[10px] uppercase font-bold text-gray-400">Download on the</p>
                  <p className="text-lg font-black">App Store</p>
                </div>
              </a>
              <a href="#" className="bg-white/10 hover:bg-white/20 border border-white/10 px-6 py-3 rounded-2xl flex items-center gap-4 transition-all group">
                <div className="text-left">
                  <p className="text-[10px] uppercase font-bold text-gray-400">Get it on</p>
                  <p className="text-lg font-black">Google Play</p>
                </div>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0 text-gray-400 font-medium">
            <p className="text-sm">
              © {currentYear} Rita. Made with ❤️ in Nigeria.
            </p>
            <div className="flex space-x-10 text-sm">
              <Link to="/privacy-policy" className="hover:text-white transition-colors">
                Privacy
              </Link>
              <Link to="/terms-of-service" className="hover:text-white transition-colors">
                Terms
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

